// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editor-class {
/*    color: #f00;
    font-size: 20px;
*/    margin: 0;
}

.rdw-suggestion-option {
    padding: 7px 5px;
    background-color: rgb(40,36,61) !important;
    border-bottom: 1px solid #f1f1f1;
}

`, "",{"version":3,"sources":["webpack://./src/features/common/ContentEditor.css"],"names":[],"mappings":"AAAA;AACA;;CAEC,KAAK,SAAS;AACf;;AAEA;IACI,gBAAgB;IAChB,0CAA0C;IAC1C,gCAAgC;AACpC","sourcesContent":[".editor-class {\r\n/*    color: #f00;\r\n    font-size: 20px;\r\n*/    margin: 0;\r\n}\r\n\r\n.rdw-suggestion-option {\r\n    padding: 7px 5px;\r\n    background-color: rgb(40,36,61) !important;\r\n    border-bottom: 1px solid #f1f1f1;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
